import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { useNeuroMessages } from './MessageContext';

//TODO: document how NeuroMessage works -JJames
const NeuroMessage = (props) => {
  const {
    children,
    className,
    id,
    values = {},
    tagName,
    shouldHideIfNotFound,
    shouldIgnoreRule,
  } = props;

  const messageContext = useNeuroMessages();
  const messageValue = messageContext.hasMessage(id);
  const messageHasRule = messageContext.messageHasRule(id);
  const isMessageRuleValid =
    shouldIgnoreRule ||
    !messageHasRule ||
    messageContext.messageRuleIsValid(id);
  const shouldRender = (messageValue || !shouldHideIfNotFound) && isMessageRuleValid;

  const renderMessage = () => {
    const props = {
      children,
      tagName: !className && tagName ? tagName : null,
      values: {
        ...messageContext.formattingValues,
        ...values,
      },
    };
    const message = messageContext.customMessages?.[id] || (
      <FormattedMessage id={id} {...props} />
    );
    const Tag = tagName || 'div';
    return className ? <Tag className={className}>{message}</Tag> : message;
  };

  return shouldRender ? renderMessage() : null;
};

NeuroMessage.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string,
  id: PropTypes.string.isRequired,
  shouldHideIfNotFound: PropTypes.bool,
  shouldIgnoreRule: PropTypes.bool,
  tagName: PropTypes.string,
  values: PropTypes.object,
};

export default NeuroMessage;
